import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import RentersHome from "../views/RentersHome.vue";
import QuoteBase from "../views/quote/QuoteBase.vue";
import { useQuoteStore } from "@/stores/root/quote";
import { validateAssurant } from "@/utils/AssurantValidation";
import LegalAssurant from "@/views/legal/LegalAssurant.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: RentersHome,
  },
  {
    path: "/quote",
    name: "quote",
    component: QuoteBase,
  },
  {
    path: "/legal",
    name: "legalAssurant",
    component: LegalAssurant,
  },
  {
    path: "/:notFound(.*)",
    name: "notFound",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const waitForStorageToBeReady = async (to: any, from: any, next: any) => {
  await (useQuoteStore as any).restored;
  validateAssurant((useQuoteStore as any).quote);
  next();
};
router.beforeEach(waitForStorageToBeReady);

export default router;
